import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductPage from "../pages/product/page";
import ThanksPage from "../pages/thanks/page";
import VaultPage from "../pages/vault/page";
import AbyssPage from "../pages/abyss/page";
import RevelationPage from "../pages/revelation/page";
import AdminPage from "../pages/admin/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/product/:id",
    element: <ProductPage />,
  },
  {
    path: "/thanks",
    element: <ThanksPage />,
  },
  {
    path: "/vault",
    element: <VaultPage />,
  },
  {
    path: "/abyss",
    element: <AbyssPage />,
  },
  {
    path: "/revelation",
    element: <RevelationPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
